'use client';

import Image from 'next/image';
import Link from 'next/link';

const SignupHeader = () => {
  return (
    <header className="bg-white">
      <div className="max-w-[1920px] mx-auto px-[80px] py-[40px]">
        <div className="flex items-center justify-center">
          {/* Logo */}
          <Link href="/" className="flex items-center" style={{ width: '367.62px', height: '94px' }}>
            <Image
              src="/logo-dark.png"
              alt="Female Fitness Finder"
              width={367.62}
              height={94}
              className="object-contain"
              priority
            />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default SignupHeader;
